/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LegalDocument
 */
export interface LegalDocument {
    /**
     * 
     * @type {number}
     * @memberof LegalDocument
     */
    id?: number;
    /**
     * HTML content for terms of service/agreement
     * @type {string}
     * @memberof LegalDocument
     */
    termsOfService?: string;
    /**
     * HTML content for privacy policy
     * @type {string}
     * @memberof LegalDocument
     */
    privacyPolicy?: string;
    /**
     * Last time terms of service was updated
     * @type {Date}
     * @memberof LegalDocument
     */
    lastUpdatedTerms?: Date;
    /**
     * Last time privacy policy was updated
     * @type {Date}
     * @memberof LegalDocument
     */
    lastUpdatedPrivacy?: Date;
    /**
     * 
     * @type {string}
     * @memberof LegalDocument
     */
    realm?: string;
}

/**
 * Check if a given object implements the LegalDocument interface.
 */
export function instanceOfLegalDocument(value: object): value is LegalDocument {
    return true;
}

export function LegalDocumentFromJSON(json: any): LegalDocument {
    return LegalDocumentFromJSONTyped(json, false);
}

export function LegalDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'termsOfService': json['termsOfService'] == null ? undefined : json['termsOfService'],
        'privacyPolicy': json['privacyPolicy'] == null ? undefined : json['privacyPolicy'],
        'lastUpdatedTerms': json['lastUpdatedTerms'] == null ? undefined : (new Date(json['lastUpdatedTerms'])),
        'lastUpdatedPrivacy': json['lastUpdatedPrivacy'] == null ? undefined : (new Date(json['lastUpdatedPrivacy'])),
        'realm': json['realm'] == null ? undefined : json['realm'],
    };
}

export function LegalDocumentToJSON(json: any): LegalDocument {
    return LegalDocumentToJSONTyped(json, false);
}

export function LegalDocumentToJSONTyped(value?: LegalDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'termsOfService': value['termsOfService'],
        'privacyPolicy': value['privacyPolicy'],
        'lastUpdatedTerms': value['lastUpdatedTerms'] == null ? undefined : ((value['lastUpdatedTerms']).toISOString()),
        'lastUpdatedPrivacy': value['lastUpdatedPrivacy'] == null ? undefined : ((value['lastUpdatedPrivacy']).toISOString()),
        'realm': value['realm'],
    };
}


